import { Alert, Button, Space, Spin } from "antd";

export function RouteTargetNotice({ loading, onBack }) {
  if (loading) {
    return (
      <Spin>
        <div style={{ minHeight: 120 }} />
      </Spin>
    );
  }
  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Alert
        type="info"
        showIcon
        message="대상을 찾을 수 없거나 조회 권한이 없습니다."
      />
      <Button onClick={onBack}>목록으로</Button>
    </Space>
  );
}
